<div #outsideModalCor class="modal">
  <div #modalBodyCor class="modal-content">
    <div class="modal-header"> {{modalTitle}} </div>
    <div class="modal-body">
      <div class="select-account-wrapper" *ngIf="currentAccount && (!isMSSSet || !isConnected)">
        <form [formGroup]="currentAccount" *ngIf="accounts && accounts.length > 0">
          <frg-form-input label="Sélectionnez un compte" [formGroup]="currentAccount" type="ngSelect"
            [selectValue]="accounts" id="accountName" [control]="currentAccount.get('accountName')" required="true"
            errorMessage="Veuillez sélectionner un compte" [isClearableSelect]="false"></frg-form-input>
          <div class="buttons-wrapper center">
            <frg-button type="button" (activated)="selectAccount(false)" [disabled]="!currentAccount.valid || !isMSSSet"
              fullWidth="true">Valider</frg-button>
          </div>
        </form>
      </div>
      <div class="center" style="padding-top: 1em;" *ngIf="currentAccount && !isMSSSet">
        <div style="color:red; margin-bottom: 1em;">
          Veuillez renseigner les informations présentes dans l'onglet de Paramétrage MSS/DMP
        </div>
      </div>
      <div class="center" style="padding-top: 1em;" *ngIf="currentAccount && (!isMSSSet || !isConnected)">
        <div style="margin-bottom: 1em;">
          * Pour ajouter/gérer des comptes Mailiz veuillez vous référer à l'interface Messagerie.
        </div>
        <frg-button (activated)="closeModal()" [backgroundColor]="'var(--darkest-primary)'">
          Fermer</frg-button>
      </div>
      <div class="no-mail-wrapper" *ngIf="isMSSSet && isConnected">
       
        <div *ngIf="!isApicryptAccount" class="message-patient-wrapper" >
          <div *ngIf="canSendToPatient" class="patientInput">
            <frg-form-input label="Patient" id="patientSubject" [formGroup]="messageFormGroup"
              [control]="messageFormGroup.get('messagePatient')" type="text" disabled="true"></frg-form-input>
          </div>
          <div *ngIf="canSendToPatient" class="sendPatient" style="margin-left: 1.5rem;">
            <div>
              <div class="envoiPatient checkbox-wrapper" *ngIf="!readOnly && !isApicryptAccount">
                <label class="checkbox">
                  <input *ngIf="messageFormGroup" id="quick-send-envoi-patient-checkbox"
                  [formGroup]="messageFormGroup" [formControl]="messageFormGroup.get('messageEnvoiPatient')"
                  (change)="toggledSendPatient($event.target.checked)" type="checkbox">
                  <span class="checkMark"></span>
                  <span class="label">Envoyer au patient</span>
                </label>
              </div>
            </div>
          </div>
          <div *ngIf="!canSendToPatient" class="envoi-patient-impossible">
              Le courrier ne sera envoyé au patient, veuillez vérifier que l'INS est bien qualifié ou que le patient n'a pas explicitement refusé de recevoir des courriers par MSS.
            </div>
        </div>
        <div class="message-recipients-wrapper">
          <mat-label style="font-weight: 500; font-size: 1.4rem; margin-bottom: 0.5rem;">Correspondants sélectionnés: </mat-label>
          <div class="recipients-input-full">
            <div class="recipient-input-like">
              <mat-chip-list #chipList aria-label="Liste des correspondants" label="Destinataires" id="messageRecipients"
                [formGroup]="messageFormGroup" [control]="messageFormGroup.get('messageRecipients')" type="text">
                <mat-chip class="custom-chip" [title]="correspondant.email" *ngFor="let correspondant of selectedRecipientsEmails; let i = index"
                  [selectable]="false" [removable]="true" (removed)="removeCorrespondant(i, 'messageRecipients')">
                  {{ correspondant.nom }} {{correspondant.prenom}}
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
              </mat-chip-list>
            </div>
            <div class="recipients-buttons">
            <frg-button title="correspondants du patient" (activated)="addCorrespondant('messageRecipients')" [type]="'button'" [disabled]="!canSendToPro">
              <div class="correspondant-icon"></div>
            </frg-button>
            <frg-button title="Ajouter des copies" (activated)="showCCandCCI()" [type]="'button'" [disabled]="!canSendToPro">CC/CCI</frg-button>
            </div>
          </div>
          <div *ngIf="isVisibleReciptients" class="recipients-input">
            <mat-label>CC</mat-label>
            <div class="recipient-input-like">
              <mat-chip-list #chipList aria-label="Liste des correspondants" label="Destinataires" id="messageCcRecipients"
                [formGroup]="messageFormGroup" [control]="messageFormGroup.get('messageCcRecipients')" type="text">
                <mat-chip class="custom-chip" [title]="correspondant.email" *ngFor="let correspondant of selectedCcRecipientsEmails; let i = index"
                  [selectable]="false" [removable]="true" (removed)="removeCorrespondant(i, 'messageCcRecipients')">
                  {{ correspondant.nom }} {{correspondant.prenom}}
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
              </mat-chip-list>
            </div>
            <frg-button title="correspondants du patient" (activated)="addCorrespondant('messageCcRecipients')" [type]="'button'" [disabled]="!canSendToPro"
                ><div class="correspondant-icon"></div>
            </frg-button> 
          </div>
          <div *ngIf="isVisibleReciptients" class="recipients-input" style="margin-left: 1.5rem;">
            <mat-label>CCI</mat-label>
            <div class="recipient-input-like">
              <mat-chip-list #chipList aria-label="Liste des correspondants" label="Destinataires" id="messageBccRecipients"
                [formGroup]="messageFormGroup" [control]="messageFormGroup.get('messageBccRecipients')" type="text">
                <mat-chip class="custom-chip" [title]="correspondant.email" *ngFor="let correspondant of selectedBccRecipientsEmails; let i = index"
                  [selectable]="false" [removable]="true" (removed)="removeCorrespondant(i, 'messageBccRecipients')">
                  {{ correspondant.nom }} {{correspondant.prenom}}
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
              </mat-chip-list>
            </div>
            <frg-button title="correspondants du patient" (activated)="addCorrespondant('messageBccRecipients')" [type]="'button'" [disabled]="!canSendToPro"
                ><div class="correspondant-icon"></div>
            </frg-button> 
          </div>
          <div class="recipients-input-full">
            <div *ngIf="!canSendToPro" class="envoi-pro-impossible">
              Le patient n'a pas donné son consentement pour l'envoi de message par MSSanté professionnel par conséquent le message ne peut pas être envoyé
            </div>
          </div>
        </div>

        <frg-form-input *ngIf="!isApicryptAccount" id="accuseReception" label="Accusé Reception" type="checkbox" isCheckLabelAlign="true"
          [formGroup]="messageFormGroup" [control]="messageFormGroup.get('messageAccuseReception')"></frg-form-input>

        <div class="message-subject-wrapper">
          <frg-form-input label="Objet" id="messageSubject" [formGroup]="messageFormGroup"
            [control]="messageFormGroup.get('messageSubject')" type="text"></frg-form-input>
        </div>
        <div style="display: none;" class="froala-wrapper" [formGroup]="messageFormGroup" *ngIf="this.pieceJointe.contentType !== 'courrier-consultation'">
           <froala-editor class="froala-editor" [froalaEditor]="editorOptions" [(froalaModel)]="editorContent"  (froalaInit)="initialize($event)"
             id="froalaDrop" #froalaDrop formControlName="messageBody" placeholder="Ajouter du texte ici..." ></froala-editor>   
        </div>
        <div *ngIf="pieceJointe">
          <div class="message-attachments-title">Pièces jointes</div>
          <div class="message-attachments">
            <div class="message-attachments-wrapper">
              <div class="attachment" [title]="pieceJointe.fileName" [ngClass]="{ 'clinical-document': pieceJointe.clinicalDocument }">
                <div class="icon"></div>
                <div class="attachment-title">{{ pieceJointe.fileName }}</div>
              </div>
              <div class="attachment" *ngFor="let annexe of annexes" [title]="annexe.fileName">
                <div class="icon"></div>
                <div class="attachment-title">{{ annexe.fileName }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons-wrapper">
          <frg-button [backgroundColor]="'var(--danger)'" (activated)="cancel()">Annuler</frg-button>
          <frg-button [disabled]="!messageFormGroup || !messageFormGroup.valid" (activated)="sendMessage()">Envoyer</frg-button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-background"></div>
